{
  AOS.init();
}
{
  const playButtons = document.querySelectorAll(".playhldrpr");
  const videos = document.querySelectorAll("video");

  function pauseAllVideos() {
    videos.forEach((video, index) => {
      video.pause();
      playButtons[index].style.display = "flex";
    });
  }

  playButtons.forEach((playButton, index) => {
    const video = videos[index];

    playButton.addEventListener("click", function () {
      pauseAllVideos();
      video.play();
      playButton.style.display = "none";
    });

    video.addEventListener("click", function () {
      if (video.paused) {
        pauseAllVideos();
        video.play();
        playButton.style.display = "none";
      } else {
        video.pause();
        playButton.style.display = "flex";
      }
    });
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const accordionItems = document.querySelectorAll(".accordion-item");
      if (accordionItems.length > 0) {
        setTimeout(() => {
            accordionItems[0].classList.add("open");
        }, 1500);
      }
    accordionItems.forEach((item) => {
      const header = item.querySelector(".accordion-item-header");
      header.addEventListener("click", () => {
        document.querySelectorAll(".accordion-item").forEach((otherItem) => {
          if (otherItem !== item && otherItem.classList.contains("open")) {
            otherItem.classList.remove("open");
          }
        });
        item.classList.toggle("open");
      });
    });

    const row_main = document.querySelectorAll(".Faqs_row .accordion-item");
    if (row_main.length > 0) {
      row_main[0].classList.add("open");
    }
  });
}

{
  const readMoreBtns = document.querySelectorAll(".readMore");
  const descriptions = document.querySelectorAll(".Dec_maint");

  descriptions.forEach((description, index) => {
    const readMoreBtn = readMoreBtns[index];

    if (description.scrollHeight > description.clientHeight) {
      readMoreBtn.style.display = "block";
    } else {
    }

    readMoreBtn.addEventListener("click", function () {
      if (description.classList.contains("expanded")) {
        description.classList.remove("expanded");
        readMoreBtn.textContent = "Read More";
      } else {
        description.classList.add("expanded");
        readMoreBtn.textContent = "View Less";
      }
    });
  });
}
